import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  BASE_ROLES,
  BaseApplication,
  BaseCoreState,
  BaseModalService,
  BaseRolesService,
  baseSharedSelectors,
  BaseButtonSize,
} from 'base';
import { filter, map, takeUntil } from 'rxjs/operators';
import { delay, noop, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BaseCustomerOnboardingService } from '../../_services/onboarding.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'base-customer-onboarding-light-banner',
  templateUrl: './onboarding-light-banner.component.html',
})
export class BaseCustomerOnboardingLightBannerComponent implements OnInit, OnDestroy {
  @ViewChild('baseOnboardingLight', { static: true }) baseOnboardingLight: ElementRef;
  @Input() logo: string;
  @Input() application: BaseApplication;
  showOnboardingBanner = false;
  isHideOnboardingUrl = true;
  modalRef: NgbModalRef;
  loadAPI: Promise<any>;
  buttonSize = BaseButtonSize;

  private destroy$ = new Subject();

  constructor(
    private store: Store<BaseCoreState>,
    private baseRolesService: BaseRolesService,
    private baseCustomerOnboardingService: BaseCustomerOnboardingService,
    private baseModalService: BaseModalService,
    private router: Router
  ) {}

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const urlRegEx = new RegExp('^(\\/auth.*|\\/[0-9]{3})$');
        this.isHideOnboardingUrl = urlRegEx.test(event.url);
      }
    });

    this.store
      .select(baseSharedSelectors.getProfile)
      .pipe(
        takeUntil(this.destroy$),
        filter((user) => !!user.data),
        map((user) => user.data),
        delay(2500)
      )
      .subscribe((userData) => {
        if (this.baseRolesService.hasRole(BASE_ROLES.CUSTOMER_ADMIN) && userData?.onboardingRequired) {
          this.showOnboardingBanner = true;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  callOnboardingModal() {
    if (!this.showOnboardingBanner) {
      return;
    }

    this.modalRef = this.baseModalService.open(
      {
        bodyTemplate: this.baseOnboardingLight,
        cancelText: 'action.close',
        okButtonDisplayed: false,
        hideHeader: true,
      },
      {
        backdrop: 'static',
        size: 'lg',
      }
    );

    this.modalRef.result.then(noop, noop);

    this.loadAPI = new Promise((resolve) => {
      this.baseCustomerOnboardingService.loadScript();
      resolve(true);
    });
  }
}
